import { useState, useEffect } from "react";
import InputFilter from "../../components/GInput/InputFilter";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function InputsFilter ({ values }) {

    const [value, setValue] = useState({});
    const navigate = useNavigate();
    const { i18n } = useTranslation();
    const t = i18n.t.bind(i18n); 
    const currentLang = i18n.language;

    useEffect(() => {

        const updatedValue = values.reduce((acc, item) => ({
            name: item.name || acc.name || "",
        }), {
            name: "",
        });
        
        setValue(updatedValue);
        
    }, [values]);

    const handleValues = (key, v) => {
        const url = new URL(window.location.href);
        const searchParams = url.searchParams;
        searchParams.delete(key);

        const newUrl = `${url.pathname}?${searchParams.toString()}${url.hash}`;
        
        navigate(newUrl, { replace: true });

        setValue(prev => ({
            ...prev,
            [key]: ""
        }));
    };

    return (<>
        <div className=" bg-thirdly rounded-t-lg px-5 py-3">
            <div className="py-2">
                <p className="text-[22px] text-left font-semibold text-white">{currentLang === "en" ? "Filters" : "الفلاتر"}</p>
            </div>
            <div className="flex sm:flex-row flex-col justify-center items-center pt-2 pb-4 gap-8">
                <div className="w-full">
                    <InputFilter placeholder={t("filters.name")} type={"text"} paramkey="name"/>
                </div>
            </div>
            <div className="flex flex-row flex-wrap justify-end items-center gap-5">
                {Object.entries(value).map(([key, v]) => ( 
                    v != "" && <div className="bg-gray-600 text-white flex justify-between items-center gap-3 rounded-lg text-md px-3 py-[2px]"><button onClick={() => handleValues(key, v)} className="bg-red-500 w-4 h-4 rounded-full text-sm text-white text-bold flex justify-center items-center">X</button> {key}: {String(v)} </div>
                ))}
            </div>
        </div>
    </>)
}